var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStoreMenuIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4446 1H2.55558C1.69646 1 1 1.69646 1 2.55558V13.4446C1 14.3037 1.69646 15.0002 2.55558 15.0002H13.4446C14.3037 15.0002 15.0002 14.3037 15.0002 13.4446V2.55558C15.0002 1.69646 14.3037 1 13.4446 1Z",
    stroke: "#7647EE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2227 21.2227H22.0004C21.5709 21.2227 21.2227 21.5709 21.2227 22.0004V28.2227C21.2227 28.6523 21.5709 29.0005 22.0004 29.0005H28.2227C28.6523 29.0005 29.0005 28.6523 29.0005 28.2227V22.0004C29.0005 21.5709 28.6523 21.2227 28.2227 21.2227Z",
    stroke: "#7647EE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2227 7.22266H22.0004C21.5709 7.22266 21.2227 7.57088 21.2227 8.00044V14.2227C21.2227 14.6523 21.5709 15.0005 22.0004 15.0005H28.2227C28.6523 15.0005 29.0005 14.6523 29.0005 14.2227V8.00044C29.0005 7.57088 28.6523 7.22266 28.2227 7.22266Z",
    stroke: "#7647EE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2223 21.2227H7.99996C7.5704 21.2227 7.22217 21.5709 7.22217 22.0004V28.2227C7.22217 28.6523 7.5704 29.0005 7.99996 29.0005H14.2223C14.6518 29.0005 15 28.6523 15 28.2227V22.0004C15 21.5709 14.6518 21.2227 14.2223 21.2227Z",
    stroke: "#7647EE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoreMenuIcon);
export default __webpack_public_path__ + "static/media/store-menu-icon.7e4ad9821770ce7f9279fb9ea53fa0f1.svg";
export { ForwardRef as ReactComponent };